import MealWrapper from './components/mealwrapper';
import './App.css';

function App() {
  return (
    <>
      <header>
        <h1>
          Mealwars
        </h1>
      </header>
      <MealWrapper/>
    </>
  );
}

export default App;
